import * as Yup from 'yup';

export const DriverLookupSearchSchema = Yup.object().shape({
  ninNumber: Yup.string()
    .min(1, 'NIN number is required')
    .required('NIN number is required'),
});

export type DriverLookupSearchDataType = Yup.InferType<
  typeof DriverLookupSearchSchema
>;

type InitialValues = {
  ninNumber: string;
};

export const DriverLookupSearchInitialValues: InitialValues = {
  ninNumber: '',
};

export interface DriverLookupSearchInterface {
  ninNumber: string;
}
